module.exports = __webpack_public_path__ + "img/pcnteam.11432d9d.svg";